


































import Vue from 'vue'
import DataItem from '@/components/DataItem.vue'

// as soon as the props were received: after the page/component loaded checkForSameInitiator will fill the array relatedEvents with events by the same initiator/organiser as current Data-Item.

export default Vue.extend({
  name: 'Popup',
  props: ['event', 'type', 'events'],
  components: {
    DataItem
  },
  data() {
    return {
      relatedEvents: new Array<Object>(),
      ready: false
    }
  },
  beforeUpdate() {
    if (this.events.length) {
      this.checkForSameInitiator();
    }
  },
  mounted() {
    if (this.events.length) {
      this.checkForSameInitiator();
    }
  },
  methods: {
    checkForSameInitiator: function() {
      let initiator = this.event.initiator;
      let i = 0;
      let newRelatedEvents= new Array<Object>();

      for (var [date_key, date] of Object.entries<any>(this.events)) {
        for (var [post_key, post] of Object.entries<any>(date["posts"])) {
          if (post["initiator"] == initiator && post["id"] != this.event.id) {
            i++;
            if (i <= 3) {
            newRelatedEvents.unshift(post);
            }
          }
        }
      }
      this.relatedEvents = newRelatedEvents;
    }
  }
});
